import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonActions,
} from 'vx-ui-components';
import styles from './styles.css';

class Breadcrumb extends React.Component {
  render() {
    const { data, delimiter, openHelpSection, closeHelpSection, help, routes } = this.props;

    const isBeta = routes.find(d => d.beta === true);

    const crumbs = data
      ? data.map((d, i) =>
          i < data.length - 1
            ? <span key={i}>{d}</span>
            : <span key={i} className={isBeta ? styles.betaLabel : null}>{d}</span>
        )
        // Insert the delimiter between crumbs
        .reduce((acc, cur, i) =>
          i === 0
            ? [cur]
            : acc.concat(
                <span key={`delimiter${i}`} className={styles.delimiter}> {delimiter} </span>,
                cur
              ), []
        )
      : false;

    return (  
      <div className={styles.breadcrumb}>
        <div className={styles.crumbs}>
          {crumbs}
        </div>
        {
          (help)
          ? routes[this.props.routes.length - 1].help && <h4 className={styles.info} onClick={openHelpSection}>?</h4> 
          : <ButtonActions onClick={closeHelpSection} btnType="link">Close help section</ButtonActions>
        }
    </div>
    );
  }
}

Breadcrumb.propTypes = {
  data: PropTypes.array,
  delimiter: PropTypes.string,
  openHelpSection: PropTypes.func.isRequired,
  closeHelpSection: PropTypes.func.isRequired,
  help: PropTypes.string.isRequired,
  routes: PropTypes.array.isRequired,
};

Breadcrumb.defaultProps = {
  delimiter: '>',
  data: undefined,
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.js